// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/locale-provider/style/index.less
// module id = 1767
// module chunks = 0